import * as u from './utils';
import dialogPolyfill from 'dialog-polyfill';

const openEvent = new Event('dialog-open');
const closeEvent = new Event('dialog-open');

export default () => {
    const triggers = document.querySelectorAll('[data-modal]');
    const linkTriggers = document.querySelectorAll('a');
    const dialogs = document.querySelectorAll('dialog');
    const closeButtons = document.querySelectorAll('[data-modal-close]');

    const openModal = (e) => {
        e.preventDefault();
        let dialog;

        if (e.currentTarget.dataset.modal) {
            dialog = document.getElementById(e.currentTarget.dataset.modal);
        } else {
            dialog = document.querySelector(e.currentTarget.getAttribute('href'));
        }
        const scrollY = window.pageYOffset;

        dialog.showModal();
        //window.scrollTo(0, scrollY);

        dialog.dispatchEvent(openEvent);
    };

    for (const el of triggers) {
        el.addEventListener('click', openModal);
    }

    for (const el of linkTriggers) {
        if (el.getAttribute('href').startsWith('#dialog-')) {
            el.addEventListener('click', openModal);
        }
    }

    const closeDialog = (dialog) => {
        dialog.dispatchEvent(closeEvent);

        dialog.close();
    };

    const handleDialogClick = (e) => {
        const dialog = e.currentTarget;
        const rect = dialog.getBoundingClientRect();
        const isInDialog =
            rect.top <= e.clientY &&
            e.clientY <= rect.top + rect.height &&
            rect.left <= e.clientX &&
            e.clientX <= rect.left + rect.width;

        if (!isInDialog) {
            closeDialog(dialog);
        }
    };

    for (const el of dialogs) {
        dialogPolyfill.registerDialog(el);
        el.addEventListener('click', handleDialogClick);
    }

    const handleCloseClick = (e) => {
        const button = e.currentTarget;
        closeDialog(button.closest('dialog'));
    };

    for (const el of closeButtons) {
        el.addEventListener('click', handleCloseClick);
    }
};
